import { Dispatch } from '../context/useNewRoleContext';

export const updateValidStepsAction = (
  stepNumber: number,
  isValid: boolean,
  previousValidSteps: number[],
  dispatch: Dispatch,
) => {
  let newValidSteps = [...previousValidSteps];

  if (previousValidSteps.includes(stepNumber) === isValid) {
    return;
  }

  if (!newValidSteps.includes(stepNumber)) {
    newValidSteps.push(stepNumber);
  } else if (newValidSteps.includes(stepNumber) && !isValid) {
    newValidSteps = newValidSteps.filter(val => val !== stepNumber);
  }

  dispatch({ type: 'UPDATE_VALID_STEPS', payload: { validSteps: newValidSteps } });
};
